import { Stack, LoadingOverlay } from '@mantine/core';
import { TransactionDisplay } from './transactions/TransactionDisplay';
import { User } from '@propelauth/react';

interface TransactionTabProps {
  accessToken: string;
  user: User;
  groupId: number;
  isVisible?: boolean;
}

export const TransactionTab = ({ accessToken, user, groupId, isVisible = true }: TransactionTabProps) => {
  return (
    <Stack className="w-full p-4" style={{ position: 'relative' }}>
      <TransactionDisplay
        accessToken={accessToken}
        user={user}
        isVisible={isVisible}
      />
    </Stack>
  );
};

export default TransactionTab; 